import React from 'react';
import { MapPin, Phone, Clock, Navigation } from 'lucide-react';
import { academyInfo } from '../data/mockData';
import { Button } from './ui/button';

const Location = () => {
  const handleGetDirections = () => {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(academyInfo.address)}`;
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Visit Our <span className="text-green-600">Academy in Bhopal</span>
          </h2>
          <p className="text-lg text-gray-600">
            Experience offline classroom training with personal attention
          </p>
        </div>

        {/* Location Content */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Address & Contact Info */}
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-green-50 to-white border-2 border-green-600 rounded-xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Academy Location</h3>
                
                {/* Address */}
                <div className="flex items-start gap-4 mb-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <MapPin className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Address</h4>
                    <p className="text-gray-700 leading-relaxed">{academyInfo.address}</p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-4 mb-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <Phone className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Contact Number</h4>
                    <a 
                      href={`tel:${academyInfo.phone}`}
                      className="text-green-600 hover:text-green-700 font-semibold text-lg transition-colors"
                    >
                      {academyInfo.phone}
                    </a>
                  </div>
                </div>

                {/* Timing */}
                <div className="flex items-start gap-4 mb-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <Clock className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Contact Timing</h4>
                    <p className="text-gray-700">Monday - Saturday: 10:00 AM - 7:00 PM</p>
                    <p className="text-gray-700">Sunday: By Appointment</p>
                  </div>
                </div>

                {/* Get Directions Button */}
                <Button 
                  onClick={handleGetDirections}
                  className="w-full bg-green-600 hover:bg-green-700 text-white py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  <Navigation className="mr-2 h-5 w-5" />
                  Get Directions on Google Maps
                </Button>
              </div>

              {/* Landmarks */}
              <div className="bg-green-50 border border-green-200 rounded-xl p-6">
                <h4 className="font-semibold text-gray-900 mb-3">Nearby Landmarks</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Above KSG IAS Coaching</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Behind Sargam Talkies</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Near Hotel Rajhans</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Zone-II, MP Nagar, Bhopal</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Google Map */}
            <div className="h-[500px] lg:h-full min-h-[400px]">
              <div className="w-full h-full rounded-xl overflow-hidden shadow-xl border-2 border-green-200">
                <iframe
                  title="Stocks Vision Academy Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.642!2d77.4126!3d23.2324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c428f8a3e3b6b%3A0x1e684190d5e9c8c3!2sMP%20Nagar%2C%20Zone-II%2C%20Bhopal%2C%20Madhya%20Pradesh%20462011!5e0!3m2!1sen!2sin!4v1640000000000!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
